"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Callbacks = void 0;
var Callbacks;
(function (Callbacks) {
    Callbacks["sync_accuracy_change"] = "sync_accuracy_change";
    Callbacks["delta_change"] = "delta_change";
    Callbacks["speed_change"] = "speed_change";
    Callbacks["leader_update"] = "leader_update";
    Callbacks["chat_update"] = "chat_update";
    Callbacks["client_list_update"] = "client_list_update";
    Callbacks["receive_command"] = "receive_command";
})(Callbacks = exports.Callbacks || (exports.Callbacks = {}));
//# sourceMappingURL=Callbacks.js.map